import { useNavigate } from "@tanstack/react-router";
import type { ReactNode } from "react";
import Checkbox from "ui/forms/Checkbox";
import type { LocationSummaryScope } from "./locationSummaryTypes";
import styles from "./LocationSummaryView.module.scss";

export default function IncludeSubLocationsCheckbox({
  scope,
}: {
  scope: Extract<LocationSummaryScope, { kind: "location" }>;
}): ReactNode {
  const navigate = useNavigate();

  return (
    <Checkbox
      label="Include sub-locations"
      labelClassName={styles.includeSubLocationsLabel}
      checked={scope.filters.includeChildren !== false}
      onChangeBoolean={(checked: boolean) => {
        void navigate({
          // No route defines validateSearch, so the router types search as never; cast keeps the untyped merge updater.
          search: ((previous: Record<string, unknown>) => ({
            ...previous,
            includeChildren: checked ? undefined : false,
          })) as never,
          replace: true,
        });
      }}
    />
  );
}
